import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import {
    IItemsListFilter,
    IItemsListFiltersData,
    IItemsListFilterSettings,
} from '@fi-shared/fi-items-list/fi-items-list-filter/fi-items-list-filter/fi-items-list-filter';
import { ModuleType, SideListOptionType } from '@fi-shared/types';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { StatisticService } from '@fi-shared/statistic/statistic.service';

interface iCurrentFilterData {
    filterSettings: IItemsListFilterSettings;
    isSuperAdminAccess: boolean;
    isFilterSettingsShown: boolean;
}

@Injectable()
export class FiItemsListFilterService {
    private currentFilters: { [prop: number]: iCurrentFilterData } = {};

    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
        private statisticService: StatisticService,
    ) {
        this.statisticService.currentModuleChanged$.subscribe((moduleType) => {
            for (let prop in this.currentFilters) {
                if (<any>prop != moduleType) {
                    delete this.currentFilters[prop];
                }
            }
        });
    }

    onFilterSettingsChanged(
        moduleType: ModuleType,
        filterSettings: IItemsListFilterSettings,
        isSuperAdminAccess: boolean,
        isFilterSettingsShown: boolean,
    ) {
        this.currentFilters[moduleType] = {
            filterSettings: filterSettings,
            isSuperAdminAccess: isSuperAdminAccess,
            isFilterSettingsShown: isFilterSettingsShown,
        };
    }

    getFiltersData(itemsListType: FiItemsListType) {
        return this.fiBackend.fetchData<IItemsListFiltersData>(`Core/ItemsList/GetFiltersData/${itemsListType}`);
    }

    saveFilter(itemsListType: FiItemsListType, filterToSave: IItemsListFilter) {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<number>(`Core/ItemsList/SaveFilter/${itemsListType}`, filterToSave),
        );
    }

    deleteFilters(itemsListType: FiItemsListType, idsToDelete: number[]) {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<void>(`Core/ItemsList/DeleteFilters/${itemsListType}`, idsToDelete),
        );
    }

    getIsSuperAdminAccess(moduleType: ModuleType) {
        const currentFilterData = this.currentFilters[moduleType];
        return currentFilterData?.isSuperAdminAccess ?? false;
    }

    getIsFilterSettingsShown(moduleType: ModuleType) {
        const currentFilterData = this.currentFilters[moduleType];
        return currentFilterData?.isFilterSettingsShown ?? false;
    }

    getFilter(moduleType: ModuleType) {
        const currentFilter = this.getNewFilterInstance();
        const currentFilterData = this.currentFilters[moduleType];
        if (currentFilterData) {
            currentFilter.Settings = currentFilterData.filterSettings;
        }
        return currentFilter;
    }

    getNewFilterInstance(): IItemsListFilter {
        return {
            Id: undefined,
            Name: '',
            Settings: {
                CategoryFilterTypes: [SideListOptionType.SharedWithMe],
                ChangedOnFilterType: undefined,
                TagIds: [],
                UserIds: [],
                BusinessUnitIds: [],
                AreaIds: [],
                ClusterIds: [],
                BusinessAreaIds: [],
            },
        };
    }
}
